export default __webpack_public_path__ + "static/media/provesional_restoration_upper_43_2@2x.f2ca2616.png";